import { fetch as fetchRaw } from '@lib/fetch';
import { getDefinedUrlSearchParams } from '@lib/util';
import { backend } from '../services';

const BASE_URL = backend.url;

const unwrapEnvelope = body => (body?.metadata ? body.data : body);

const fetch = async (url, ...args) => {
  const response = await fetchRaw([BASE_URL, url], ...args);
  return { ...response, data: unwrapEnvelope(response.data) };
};

export function getCompanyChainList(queryParams) {
  return fetch(
    `/supplychain-mappings/collaborations?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function supplyChainsBulkRefreshCalculation(body) {
  return fetch('/supplychain-mappings/bulk-refresh-calculation', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainsBulkInvitationReminders(body) {
  return fetch('/supplychain-mappings/bulk-invitation-reminders', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainsBulkArchive(body) {
  return fetch('/supplychain-mappings/bulk-archive', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function supplyChainsBulkUnArchive(body) {
  return fetch('/supplychain-mappings/bulk-unarchive', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getCompanyChain(collaborationId) {
  return fetch(`/supplychain-mappings/collaborations/${collaborationId}`, {
    method: 'GET',
  });
}

export function getFullCompanyChain(collaborationId) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/expand-all`,
    {
      method: 'GET',
    },
  );
}

export function companySupplyChainCreate(body) {
  return fetch('/supplychain-mappings', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function companiesLinkIntoSupplyChain(collaborationId, body) {
  return fetch(`/supplychain-mappings/collaborations/${collaborationId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function companiesUnMapped(nodeId, queryParams) {
  return fetch(
    `/supplychain-mappings/nodes/${nodeId}/unmapped-company-profiles?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function supplyChainsBulkExport(body) {
  return fetch('/supplychain-mappings/export', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function getCompanyChainExpandNodes(nodeId, queryParams) {
  return fetch(
    `/supplychain-mappings/nodes/${nodeId}/expand?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function supplyChainsBulkDuplicate(body) {
  return fetch('/supplychain-mappings/bulk-duplicate', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function inviteCollaborators(body) {
  return fetch('/supplychain-mappings/collaborators', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function acceptCollaboration(collaborationId, body = {}) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/accept`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function bulkAttachExistingSupplyChain(body) {
  return fetch('/supplychain-mappings/bulk-attach-existing', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function patchExistingSupplyChain(body) {
  return fetch('/supplychain-mappings/reuse', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

// is there use of it anywhere?
export function getSupplyChainCompaniesList(companyChainId, queryParams) {
  return fetch(
    `/supplychain-mappings/${companyChainId}/companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function invitationReminder(collaborationId, body) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/invitation-reminders`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function updateNodeFacilityProcess(nodeId, body) {
  return fetch(`/supplychain-mappings/nodes/${nodeId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getSupplyChainSingleNode(nodeId) {
  return fetch(`/supplychain-mappings/nodes/${nodeId}`, {
    method: 'GET',
  });
}

export function getSupplyChainUpstreamNodesByNodeId(nodeId) {
  return fetch(`/supplychain-mappings/nodes/${nodeId}/descedants`, {
    method: 'GET',
  });
}

export function deleteSupplyChainNodeWithUpstreamConnections(nodeId) {
  return fetch(`/supplychain-mappings/nodes/${nodeId}`, {
    method: 'DELETE',
  });
}

export function updateSupplyChainMetadata(collaborationId, body) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/metadata`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function replaceSupplyChainNode(nodeId, body) {
  return fetch(`/supplychain-mappings/nodes/${nodeId}/replace`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function getCollaborationMapDetails(id) {
  return fetch(`/supplychain-mappings/collaborations/${id}/map`, {
    method: 'GET',
  });
}

export function getSupplierStatistics() {
  return fetch('/supplychain-mappings/supplier-statistics/', {
    method: 'GET',
  });
}

export function updateSupplyChainStatus(collaborationId, body) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/status`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function getMappedCompaniesList(queryParams) {
  return fetch(
    `/supplychain-mappings/mapped-companies?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getSingleSupplierDetails(companyId, filter) {
  const qs = filter ? `?filter=${encodeURIComponent(filter)}` : '';
  return fetch(`/supplychain-mappings/insights/suppliers/${companyId}${qs}`, {
    method: 'GET',
  });
}
export function getGlobalSupplyChainBoardData() {
  return fetch('/supplychain-mappings/insights/global-diagram/', {
    method: 'GET',
  });
}

export function getHistories(queryParams) {
  return fetch(
    `/supplychain-mappings/history?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getCollaboratorsList(queryParams) {
  return fetch(
    `/supplychain-mappings/collaborators?${getDefinedUrlSearchParams(queryParams)}`,
    {
      method: 'GET',
    },
  );
}

export function getCriticalSuppliersList() {
  return fetch('/supplychain-mappings/critical-suppliers-statistics', {
    method: 'GET',
  });
}

export function getFacilityProcessOverview() {
  return fetch('/supplychain-mappings/facility-process-overview', {
    method: 'GET',
  });
}

export function updateCollaborationStatus(collaborationId, body) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/collaboration-status`,
    {
      method: 'PATCH',
      body: JSON.stringify(body),
    },
  );
}

export function getCollaborationCollaborators(collaborationId, body) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/collaborators/list`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}

export function getCollaborationCommunications(collaborationId, body) {
  return fetch(
    `/supplychain-mappings/collaborations/${collaborationId}/communications/list`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  );
}
